import { render, staticRenderFns } from "./KhoTLTForm.vue?vue&type=template&id=40da24ec&scoped=true&"
import script from "./KhoTLTForm.vue?vue&type=script&lang=js&"
export * from "./KhoTLTForm.vue?vue&type=script&lang=js&"
import style0 from "./KhoTLTForm.vue?vue&type=style&index=0&id=40da24ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da24ec",
  null
  
)

export default component.exports